<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <input 
      class="active-input number-input" 
      [class.error]="formControl.invalid"
      type="{{field.props.type || 'number'}}"
      inputmode="numeric"
      [min]="field.props.min || null"
      [max]="field.props.max || null"
      placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
      autocomplete="true"
      [formControl]="$any(formControl)" 
      [formlyAttributes]="field"
      (change)="change($event)">
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      {{(formControl.value) | localeNumber:field.props['format'] || 'compact': field.props['digits']}}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>